import React from 'react';
import {
  Create,
  SimpleForm,
  TextInput,
} from 'react-admin';

const CodigoRechazoCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="descripcion" />
    </SimpleForm>
  </Create>
);

export default CodigoRechazoCreate;
